 
/* eslint-disable camelcase */
import {read} from '../../smartpak/cookie';
import ko from 'knockout';
import $ from 'jquery';
import pagination from './pagination';

function SearchResult(data) {
    Object.keys(data).forEach(key => {
        this[key] = data[key];
    });

    this.urlDisplay = `${location.origin}${this.link}`;
}

function generateRequestId() {
    return Math.floor(Math.random() * (9999999999999 - 1 + 1)) + 1;
}

function getBloomreachCookie() {
    return read('_br_uid_2');
}

function getPageLinks() {
    var $links = $('#bloomreachContentContainer .pagelist');
    return $links;
}

function handleTabDisplay(articleCount, productCount) {
    const $articlesAndVideosTab = document.querySelector('.articlesAndVideosTab');

    if (!$articlesAndVideosTab) {
        return;
    }

    const $articleCountElement = $articlesAndVideosTab.querySelector('#articleCount');

    if (!$articleCountElement) {
        return;
    }

    if (articleCount === 0) {
        $articlesAndVideosTab.remove();
        return;
    }

    if (productCount === 0 && articleCount > 0) {
        $articlesAndVideosTab.click();
    }

    $articleCountElement.innerHTML = `Articles & Videos (${articleCount})`;
}

function SearchPageViewModel(searchTerm, products) {
    this.startPage = 1;
    this.maxPerPage = 10;
    this.countResults = ko.observable();
    this.searchTerm = searchTerm;
    this.resultsDisplay = ko.observable();
    this.contentResults = ko.observableArray();
    this.pagination = ko.observableArray([]);
    this.visiblePaginationPage = ko.observableArray([]);
    this.currentPage = ko.observable();
    this.paginationOffset = this.maxPerPage - 1;
    this.lastPage;
    this.totalNumberOfArticles;
    this.numberOfPages;
    this.pagesArray;

    this.fetchByPageNumber(this.startPage).then(response => {
        this.totalNumberOfArticles = response.numFound;
        this.setResultsDisplay(this.startPage, this.totalNumberOfArticles);
        this.currentPage(this.startPage);
        this.initializePagination(this.totalNumberOfArticles);
        this.contentResults(response.docs.map(searchResult => new SearchResult(searchResult)));
        pagination(getPageLinks(), this.startPage);
        handleTabDisplay(this.totalNumberOfArticles, products.length);
    });
}

SearchPageViewModel.prototype.handleNextPageClick = function () {
    const nextPage = this.currentPage() + 1;
    this.handlePageChange(nextPage);
};

SearchPageViewModel.prototype.handlePreviousPageClick = function () {
    const previousPage = this.currentPage() - 1;
    this.handlePageChange(previousPage);
};

SearchPageViewModel.prototype.calculateRequestPage = function (clickedPage) {
    return clickedPage === 1 ? clickedPage : clickedPage * this.maxPerPage - this.paginationOffset;
};

SearchPageViewModel.prototype.handlePageChange = function (data) {
    const requestedPage = this.calculateRequestPage(data);

    this.currentPage(data);
    this.fetchByPageNumber(requestedPage).then(response => {
        const articlesFound = response.docs.length;
        this.contentResults(response.docs.map(searchResult => new SearchResult(searchResult)));
        this.setResultsDisplay(requestedPage, articlesFound);
    });

    pagination(getPageLinks(), data);
};

SearchPageViewModel.prototype.initializePagination = function (numberFound) {
    this.numberOfPages = numberFound / this.maxPerPage;
    this.pagesArray = Array.from(new Array(Math.ceil(this.numberOfPages)), (x, i) => i + 1);
    this.pagination(this.pagesArray.length > 1 ? this.pagesArray : 0);
    this.lastPage = this.pagesArray.at(-1);
};

SearchPageViewModel.prototype.setResultsDisplay = function (start, numberOfArticles) {
    if (numberOfArticles > 1) {
        var calculatePageEnd;
        if (numberOfArticles >= this.maxPerPage) {
            calculatePageEnd = start + this.paginationOffset;
            this.resultsDisplay(start + '-' + calculatePageEnd);
        } else if (numberOfArticles > 1 && numberOfArticles < this.maxPerPage) {
            calculatePageEnd = start - 1 + numberOfArticles;
            this.resultsDisplay(start + '-' + calculatePageEnd);
        }
    } else {
        this.resultsDisplay(start);
    }
};

SearchPageViewModel.prototype.fetchByPageNumber = function (currentPage) {
    return new Promise(resolve => {
        var sendData = {
            _br_uid_2: getBloomreachCookie(),
            account_id: 5331,
            catalog_name: 'content_en',
            auth_key: '',
            domain_key: 'smartpak',
            fl: 'item_id,description,title,link',
            q: this.searchTerm,
            ref_url: window.location.origin,
            request_id: generateRequestId(),
            request_type: 'search',
            rows: this.maxPerPage,
            search_type: 'keyword',
            start: currentPage - 1,
            url: window.location.href
        };

        $.ajax({url: smartPak.pageData.brSearchUrl, method: 'GET', dataType: 'json', data: sendData}).done(function ({
            response
        }) {
            resolve(response);
        });
    });
};

export default SearchPageViewModel;
